export const STANDARD_BILLING_PERIOD_DAYS = [30, 90, 180, 365];

export const BILLING_PERIOD_LABEL_KEYS = {
  30: 'PERIOD_ONE_MONTH',
  90: 'PERIOD_THREE_MONTHS',
  180: 'PERIOD_SIX_MONTHS',
  365: 'PERIOD_TWELVE_MONTHS',
};

export const BILLING_PERIOD_SUFFIX_KEYS = {
  30: 'PER_MONTH',
  90: 'PER_THREE_MONTHS',
  180: 'PER_SIX_MONTHS',
  365: 'PER_YEAR',
};

export const BILLING_PERIOD_UNAVAILABLE_KEY = 'PERIOD_UNAVAILABLE';
